














































import gql from 'graphql-tag'
import config from '@/config/app'
import XButton from '@/components/atoms/Button/XButton.vue'
import PayjpButton from '@/components/atoms/Payjp/PayjpButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XConfirm from '@/components/atoms/Confirm/XConfirm.vue'
import CreditCardInfo from './CreditCardInfo.vue'
import loadingMixin from '@/mixin/loadingMixin'
import confirmMixin from '@/mixin/confirmMixin'

export interface CreditCard {
  cardId: string
  expYear: string
  expMonth: string
  name: string
  type: string
  isMain: boolean
}

export type DataType = {
  payjpKey: string
  creditCard: CreditCard | null
}

const CREDIT_CARD_QUERY = gql`
  query CreditCard {
    creditCard {
      cardId
      name
      expYear
      expMonth
      type
      last4
    }
  }
`

const CREATE_CREDIT_CARD_MUTATION = gql`
  mutation CreateCreditCard($paymentToken: String!) {
    createCreditCard(paymentToken: $paymentToken) {
      cardId
      name
      expYear
      expMonth
      type
      last4
    }
  }
`

const DELETE_CREDIT_CARD_MUTATION = gql`
  mutation DeleteCreditCard($id: ID!) {
    deleteCreditCard(id: $id)
  }
`

export default confirmMixin.extend({
  name: 'CreditCard',
  components: {
    XCard,
    XButton,
    XConfirm,
    PayjpButton,
    CreditCardInfo,
  },
  mixins: [loadingMixin],
  data(): DataType {
    return {
      payjpKey: config.payjpKey,
      creditCard: null,
    }
  },
  methods: {
    onCardCreated(paymentToken: string) {
      this.$apollo.mutate({
        mutation: CREATE_CREDIT_CARD_MUTATION,
        variables: { paymentToken },
        update: (_, { data: { createCreditCard } }) => {
          this.creditCard = createCreditCard
        },
      })
    },
    onCardFailed({ code, error }: { code: number; error: Error }) {
      console.debug(code, error)
      throw error
    },
    onDeleteCard(card: CreditCard) {
      const okHandler = async () => {
        await this.$apollo.mutate({
          mutation: DELETE_CREDIT_CARD_MUTATION,
          variables: { id: card.cardId },
          update: () => {
            this.creditCard = null
          },
        })
      }
      this.showConfirm({ name: card.cardId, okHandler })
    },
    handleClick() {
      this.$router.push({ name: 'Account' })
    },
  },
  apollo: {
    creditCard: {
      query: CREDIT_CARD_QUERY,
    },
  },
})
